var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertNotification2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-652.268 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#5849f6",
    rx: 8,
    transform: "translate(652.268 228)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.208 11H.791a.78.78 0 0 1-.722-.321.79.79 0 0 1 .1-.793L5.816.475A.837.837 0 0 1 6.505 0a.823.823 0 0 1 .678.467l5.649 9.424a.784.784 0 0 1 .1.788.781.781 0 0 1-.724.321zM6.5 8.034a.751.751 0 0 0-.76.807.809.809 0 0 0 .217.591.742.742 0 0 0 .543.218.755.755 0 0 0 .769-.808.749.749 0 0 0-.769-.808zm0-5.482a.521.521 0 0 0-.378.172 1.02 1.02 0 0 0-.248.737l.114 3.011c.018.5.247.909.51.909s.491-.408.509-.909l.115-3.011a1.02 1.02 0 0 0-.246-.737.519.519 0 0 0-.376-.172z",
    transform: "translate(657.768 234.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertNotification2);
export default __webpack_public_path__ + "static/media/alert-notification-2.f0b964098a47acfc781c402a8ce63306.svg";
export { ForwardRef as ReactComponent };